/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeBlockElementTypes.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Element Type Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Thursday, September 27, 2018 - 11:47:40 AM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      09/27/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const ELEMENTTYPE_LIST_CONTAINER_LOADED = 'ELEMENTTYPE_LIST_CONTAINER_LOADED';
export const ELEMENTTYPE_LIST_CONTAINER_UNLOADED = 'ELEMENTTYPE_LIST_CONTAINER_UNLOADED';
export const ELEMENTTYPE_LIST_TABLE_LOADED = 'ELEMENTTYPE_LIST_TABLE_LOADED';
export const ELEMENTTYPE_LIST_TABLE_UNLOADED = 'ELEMENTTYPE_LIST_TABLE_UNLOADED';

export const ELEMENTTYPE_SELECT_ROW = 'ELEMENTTYPE_SELECT_ROW';

export const ELEMENTTYPE_ADD = 'ELEMENTTYPE_ADD';
export const ELEMENTTYPE_EDIT = 'ELEMENTTYPE_EDIT';
export const ELEMENTTYPE_DELETE = 'ELEMENTTYPE_DELETE';
export const ELEMENTTYPE_OPEN_WARNING = 'ELEMENTTYPE_OPEN_WARNING';
export const ELEMENTTYPE_CLOSE_WARNING = 'ELEMENTTYPE_CLOSE_WARNING';

export const ELEMENTTYPE_EDIT_CONTAINER_LOADED = 'ELEMENTTYPE_EDIT_CONTAINER_LOADED';
export const ELEMENTTYPE_EDIT_CONTAINER_UNLOADED = 'ELEMENTTYPE_EDIT_CONTAINER_UNLOADED';
export const ELEMENTTYPE_EDIT_FORM_LOADED = 'ELEMENTTYPE_EDIT_FORM_LOADED';
export const ELEMENTTYPE_EDIT_FORM_UNLOADED = 'ELEMENTTYPE_EDIT_FORM_UNLOADED';

export const ELEMENTTYPE_UPDATE_FIELD = 'ELEMENTTYPE_UPDATE_FIELD';
export const ELEMENTTYPE_DRAW_OPTION_SWITCHES = 'ELEMENTTYPE_DRAW_OPTION_SWITCHES';
export const ELEMENTTYPE_DRAW_VALIDATION_SWITCHES = 'ELEMENTTYPE_DRAW_VALIDATION_SWITCHES';

export const ELEMENTTYPE_EDIT_DATA_LOAD = 'ELEMENTTYPE_EDIT_DATA_LOAD';
export const ELEMENTTYPE_EDIT_FIELDSET_LOADED = 'ELEMENTTYPE_EDIT_FIELDSET_LOADED';

export const ELEMENTTYPE_EDIT_CONTAINER_SUBMIT = 'ELEMENTTYPE_EDIT_CONTAINER_SUBMIT';
export const ELEMENTTYPE_EDIT_CONTAINER_CANCEL = 'ELEMENTTYPE_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeBlockElementTypes.js